import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Header from "../../Layouts/Header";
import Loading from "../../Layouts/Loading";

import InvitePic from "../../Assets/Images/invite.jpg";
import {TbArrowBadgeLeft} from "react-icons/tb";
import Toast from "../../Components/Toast";



const InviteOthers = () => {

    const [user , setUser] = React.useState([]);
    const [ , setHasToken] = React.useState(false);
    const [isLoaded, setIsLoaded] = React.useState(true);
    const [mobile, setMobile] = React.useState('');
    // const [name, setName] = React.useState('');
    const [buttonText, setButtonText] = React.useState('ارسال');
    const [loading, setLoading] = React.useState('d-none');
    const [buttonStatus, setButtonStatus] = React.useState("disabled");

    React.useEffect(() => {

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            window.location.replace('/login')
        }
        if(token) {
            setHasToken(true)
            setIsLoaded(false);

            API.getUserInfo()
                .then((response) => {
                    setIsLoaded(true);
                    setUser(response.data.user);
                })
                .catch((error) => {
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
    }, []);

    const onMobileChange = (event) => {
        const mobile = event.target.value;
        if (mobile.length >= 12) {
            return false;
        }
        if (mobile[0] === '0' && mobile[1] === '9' && mobile.length === 11) {
            setButtonStatus("")
        } else {
            setButtonStatus("disabled")
        }
        setMobile(mobile);
    }

/*    const onNameChange = (event) => {
        setName(event.target.value);
    }*/

    const onButtonClick =  () => {
        setButtonText("");
        setLoading("d-inline-block");
        setButtonStatus("disabled");

        const request = {
            mobile: mobile,
            // name: name,
            code: user.code
        }

        API.sendInviteSMS(request)
            .then((response) => {
                toast.success(response.message);
                setButtonText("ادامه");
                setLoading("d-none")
                setButtonStatus('')
                setMobile('')

            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setButtonText("ادامه");
                setLoading("d-none")
                setButtonStatus('')
            });
    }

    const share = () => {
        navigator.share({
            text: 'برای استفاده از خدمات نظافتی نظیر قالی شویی، مبل شویی، خشک شویی و ... اپلیکیشن سورج را نصب کن',
            url: `https://app.sooraj.ir/invite/${user.code}`
        })
    }
    return (
        <React.Fragment>
            <Toast />
            <Header title=' دعوت از دوستان' hasBack={true} />
            {
                !isLoaded && <Loading />
            }

            <main className="container-fluid ">
                <div className="row px-3 ">

                    <div className="col-12 " >
                        <img src={InvitePic} alt="Sooraj" className="rounded mx-auto d-block mt-5 w-100" />
                    </div>
                    <div className="col-12 mb-5 p-4 rtl text-justify border rounded text-small-3">
                        با معرفی اپلیکیشن سورج به دیگران می توانید از سفارش هایی که توسط افراد معرفی شده توسط شما پاداش دریافت کنید
                    </div>

                    <div className="col-12 rtl text-end text-small-2 fw-bold">
                            لینک اختصاصی شما برای دعوت دوستان به اپلیکیشن سورج:
                    </div>
                    <div className='col-12'>
                       <div className='alert alert-dark bg-black text-white p-1 mt-4 text-center'
                       onClick={share}
                       >
                           https://app.sooraj.ir/invite/{user.code}
                       </div>
                    </div>


                </div>

                <div className="row my-5 mx-3 px-2 bg-custom pb-5">
                    <div className="col-12 rtl text-end text-small-2 fw-bold text-success pt-3">
                        همچنین  برای دعوت از دیگران می توانید شماره همراه آنها را وارد کرده و دکمه ارسال را بزنید
                    </div>

                    <div className="col-12 mt-3 ">
{/*                        <div className="form-floating mb-3">
                            <input type="text"
                                   className="form-control text-center text-big-2 "
                                   id="floatingInput"
                                   placeholder="  "
                                   value={name}
                                   onChange={onNameChange}
                            />
                            <label htmlFor="floatingInput" className="end-0 start text-secondary text-small-1 text-end">نام </label>
                        </div>*/}
                        <div className="form-floating mb-3">
                            <input type="tel"
                                   className="form-control text-center text-big-2 "
                                   id="floatingInput"
                                   placeholder="شماره  موبایل"
                                   value={mobile}
                                   onChange={onMobileChange}
                            />
                            <label htmlFor="floatingInput" className="end-0 text-secondary text-small-1 text-end">شماره  موبایل</label>
                        </div>
                    </div>

                    <div className='col-12 mt-3'>
                        <button
                            className="btn btn-success text-center text-small-1 text-semi-big  w-100 p-2  pr-4 border-0"
                            onClick={onButtonClick}
                            disabled={buttonStatus}
                        >
                            {buttonText}
                            <span className="badge  p-2 float-start">
<TbArrowBadgeLeft className='text-big-3' />
                    </span>
                            <span  className={"spinner-grow spinner-grow-sm " + loading} role="status"
                                   aria-hidden="true">

                            </span>
                        </button>
                    </div>
                </div>
            </main>

        </React.Fragment>
    );
};

export default InviteOthers;